import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../services/auth.service';
import { LogService } from '../../../../../services/log.service';
import { BaseFormComponent } from '../../../../../shared/components/base-form/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ILogModel } from '../../../../../models/log.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-osa-execucao-aba-matriz-constatacao-detalhe',
  templateUrl: './modal-historico-matriz-constatacao-detalhe.component.html',
  styleUrls: ['./modal-historico-matriz-constatacao-detalhe.component.scss']
})
export class ModalHistoricoMatrizConstatacaoDetalheComponent extends BaseFormComponent implements OnInit {
  public model: ILogModel = {} as ILogModel;

  constructor(
    private dialogRef: MatDialogRef<ModalHistoricoMatrizConstatacaoDetalheComponent>,
    route: ActivatedRoute,
    router: Router,
    toastr: ToastrService,
    localeService: BsLocaleService,
    private logService: LogService,
    public authService: AuthService,
    public matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.id = data?.id;
    this.model = data?.historico;
    this.titulo = 'Detalhamento da Alteração';
  }

  ngOnInit(): void {
  }

  public fechar() {
    this.dialogRef.close();
  }
}
